import { Action, createReducer, on } from '@ngrx/store';
import { INITIAL_CONFIG } from '@shared/config';
import { AppConfig } from '@shared/interfaces';
import { loginSuccess } from './config.actions';

export interface AppConfigState extends AppConfig {
  local: boolean;
}

export const initialState = {
    ...INITIAL_CONFIG,
    local: true
};

const configReducer = createReducer(
  initialState,
  on(loginSuccess, (state, { config }) => ({...state, ...config, local: false}))
);

export function reducer(state: AppConfigState, action: Action) {
    return configReducer(state, action);
}
